import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable, { createTheme } from "react-data-table-component";
import { Modal, Button, Form, Spinner, Card } from "react-bootstrap";
import Pengaturan from "./components/pengaturan";
function Scheduler() {
  const [search, setSearch] = useState("");
  const [cari, setCari] = useState("");
  const [loading, setLoading] = useState(false);
  const [posts, setPosts] = useState([]);
  const [diCari, setDiCari] = useState("");
  //let nmr=1;
  const [nmr, setNmr] = useState(1);
  const columns = [
    {
      name: "Nama Scheduler",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Waktu Eksekusi",
      selector: (row) => row.tgl_eksekusi,
      sortable: true,
    },
    {
      name: "Start Date",
      selector: (row) => <>{row.tgl_mulai + " " + row.start_time}</>,
      sortable: true,
      width: "150px",
    },
    {
      name: "Interval",
      selector: (row) => <>{row.interval}</>,
      sortable: true,
      width: "150px",
    },
  ];
  const nomor = (p, rpg) => {
    console.log("per page", rpg);
    setNmr((p - 1) * rpg);
  };
  useEffect(() => {
    ambilData();
  }, [search]);
  const ambilData = async () => {
    const params = { cari: search, router: localStorage.getItem("rtr") };
    const headers = { "Access-Control-Allow-Origin": "*" };
    setLoading(true);
    await axios
      .get(Pengaturan["urlApi"] + "schedulergetall", { params }, { headers })
      .then((response) => {
        setPosts(response.data);
      });
    setLoading(false);
  };
  const isi = () => {
    if (loading) {
      return (
        <div className="row justify-content-center">
          <br />
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      );
    } else {
      return (
        <div className="row justify-content-center">
          <div className="col-md-12">
            <DataTable
              className="table table-striped"
              columns={columns}
              data={posts}
              pagination={true}
              paginationPerPage={10}
              onChangePage={(page, paginationPerPage) => {
                nomor(page, paginationPerPage);
              }}
            />
          </div>
        </div>
      );
    }
  };
  return (
    <>
      <div className="row justify-content-md-center">
        <div className="col-md-6 text-right">
          <strong>Scheduler (100)</strong>&nbsp;
        </div>
        <div className="col-md-6 justify-content-end">
          <input
            type="text"
            style={{ width: "70%" }}
            placeholder="Cari..."
            onChange={(e) => {
              if (e.target.value.length > 0) {
                setDiCari(e.target.value);
              } else {
                setSearch("");
              }
            }}
            onKeyDown={(event) => {
              if (event.key == "Enter") {
                setSearch(diCari);
              }
            }}
          />
          &nbsp;
          <button
            className="btn btn-primary btn-sm"
            onClick={() => {
              setSearch(diCari);
            }}
          >
            Cari
          </button>
        </div>
      </div>
      {isi()}
    </>
  );
}
export default Scheduler;
